<template>
    <section>
        <bread-crumb></bread-crumb>
        <progress-bar :order_status="detailInfo.order_status"></progress-bar>
        <service-info :detail-info="detailInfo"></service-info>
        <div class="componet-wrap">
            <div class="left-componet">
                <contact-info :detail-info="detailInfo"></contact-info>
                <screen-shot-info title="截图信息" :detail-info="detailInfo"></screen-shot-info>
                <screen-shot-info title="补充信息" :detail-info="detailInfo" v-if="detailInfo.order_supplement_img && detailInfo.order_supplement_img.length"></screen-shot-info>
            </div>
            <protocol-info class="right-componet">
                <div class="btn-text">
                    <span @click="follow" v-if="detailInfo.order_status != 7">查看进度</span>

                    <!-- 1待支付 2待处理 3 处理中 4待确认 5已完成 6已撤单 7 取消订单 8 已驳回 9已退款 10退款中 11未解决 -->
                    <div v-if="detailInfo.order_status == 1">
                        <button @click="isSuppleShow = true" class="supply" v-if="!detailInfo.order_supplement">补充</button>
                        <button @click="payMent" class="pay" :class="!detailInfo.order_supplement ? '' : 'two-w'">付款</button>
                        <button @click="cancelRefundComplete(1)" class="rescind">取消订单</button>
                    </div>

                    <!-- 3处理中（已分配业务员) -->
                    <div v-else-if="detailInfo.order_status == 3 || detailInfo.order_status == 13">
                        <button @click="isSuppleShow = true" class="supply two-w">补充</button>
                        <button @click="cancelRefundComplete(2)" class="rescind" v-if="detailInfo.isOverFive">退款</button>
                        <button @click="isRescindShow = true" class="rescind" v-else>撤单</button>
                    </div>

                    <!-- 4待确认 -->
                    <div v-else-if="detailInfo.order_status == 4">
                        <button @click="isSuppleShow = true" class="supply" v-if="!detailInfo.order_supplement">补充</button>
                        <button @click="cancelRefundComplete(3)" class="pay" :class="!detailInfo.order_supplement ? '' : 'two-w'">完成</button>
                        <button @click="isRejectShow = true" class="rescind">驳回</button>
                    </div>

                    <!-- 5已完成 -->
                    <div v-else-if="detailInfo.order_status == 5">
                        <button @click="isSuppleShow = true" v-if="!detailInfo.order_supplement" class="supply" :class="!detailInfo.order_supplement ? 'two-w' : ''">补充</button>
                        <button @click="comment" v-if="detailInfo.is_comment == 1" class="pay" :class="!detailInfo.order_supplement ? '' : 'one-w'">吐槽</button>
                        <button v-if="detailInfo.is_comment == 2" class="debunk" :class="!detailInfo.order_supplement ? '' : 'one-w'">已吐槽</button>
                    </div>

                    <!-- 8已驳回-->
                    <div v-else-if="detailInfo.order_status == 8">
                        <button @click="isSuppleShow = true" v-if="!detailInfo.order_supplement" :class="!detailInfo.order_supplement ? 'two-w' : ''" class="supply">补充</button>
                        <button @click="cancelRefundComplete(3)" :class="!detailInfo.order_supplement ? '' : 'one-w'" class="pay">完成</button>
                    </div>

                    <!-- 9已退款 10退款中 11未解决 9 10的退款直接去退款详情页面 11的退款才是弹框直接退款-->
                    <div v-else-if="detailInfo.order_status == 9 || detailInfo.order_status == 10 || detailInfo.order_status == 11">
                        <button @click="isSuppleShow = true" v-if="!detailInfo.order_supplement" class="supply" :class="!detailInfo.order_supplement ? 'two-w' : ''">补充</button>
                        <button @click="toRefundDetail" v-if="detailInfo.order_status == 9 || detailInfo.order_status == 10" class="rescind">退款</button>
                        <button @click="cancelRefundComplete(2)" v-if="detailInfo.order_status == 11" class="rescind">退款</button>
                    </div>

                    <!-- <div>
            <button class="supple" @click="isSuppleShow=true">补充</button>
            <button class="rescind" @click="isRescindShow=true">撤单</button>
            <button class="rescind" @click="isRefundShow=true">退款</button>
          </div> -->
                </div>
            </protocol-info>
        </div>

        <!-- 退款详情页弹框 -->
        <refund-modal v-if="isRefund" :order_uuid="order_uuid" @close="isRefund = false"></refund-modal>

        <!-- 吐槽弹框 -->
        <comment-modal v-show="isCommentShow" @close="isCommentShow = false" @commentBack="getOrderDetail()" ref="comment"></comment-modal>

        <!-- 驳回弹框 -->
        <reject-modal v-show="isRejectShow" @close="isRejectShow = false" ref="reject"></reject-modal>

        <!-- 取消订单 -->
        <common-tips v-if="isCommonShow" @close="isCommonShow = false" :tip-data="tipData" @submitTips="submitTips"></common-tips>

        <!-- 支付成功弹框 -->
        <pay-success-modal v-if="isSuccess" :charge-money="chargeMoney" :order_uuid="order_uuid" type="pay" @backDetail="backDetail"></pay-success-modal>

        <!-- 支付弹框 -->
        <pay-modal
            @close="close"
            @getCallBack="getCallBack"
            v-if="isPayModal"
            :charge-money="chargeMoney"
            :order_uuid="order_uuid"
            :order_member_price="order_member_price"
            type="pay"
            ref="payModal"
        ></pay-modal>

        <!-- 补充资料 -->
        <supply-modal v-if="isSuppleShow" @submit="submitSupple" @close="isSuppleShow = false"></supply-modal>

        <!-- 撤单 -->
        <rescind-modal v-if="isRescindShow" @close="isRescindShow = false" @showAgreeMent="isShowAgreeMent = true" @showRefund="isRefund = true"></rescind-modal>

        <!-- 协议 -->
        <agree-ment-modal v-if="isShowAgreeMent" @close="isShowAgreeMent = false"></agree-ment-modal>
    </section>
</template>

<script>
import BreadCrumb from '@/components/BreadCrumb.vue';
import ProgressBar from './components/progressBar.vue';
import serviceInfo from './components/serviceInfo.vue';
import contactInfo from './components/contactInfo.vue';
import screenShotInfo from './components/screenShotInfo.vue';
import protocolInfo from './components/protocolInfo.vue';
import agreeMentModal from '@/components/agreeMentModal.vue';
import commonModal from '@/components/commonModal.vue';
import supplyModal from '@/components/supplyModal.vue';
import rescindModal from '@/components/rescindModal.vue';
import payModal from '@/components/payModal';
import commonTips from '@/components/commonTips';
import rejectModal from '@/components/rejectModal';
import paySuccessModal from '@/components/paySuccessModal';
import commentModal from '@/components/commentModal';
import refundModal from '@/components/refundModal';
import { getOrderDetail, getOrderList, getOrderPay, operateOrder } from '@/api/order.js';
import utils from '@/assets/js/utils';
export default {
    components: {
        BreadCrumb,
        ProgressBar,
        serviceInfo,
        contactInfo,
        screenShotInfo,
        protocolInfo,
        agreeMentModal,
        commonModal,
        supplyModal,
        rescindModal,
        payModal,
        commonTips,
        rejectModal,
        paySuccessModal,
        commentModal,
        refundModal
    },
    data() {
        return {
            isClick: 0,
            tabs: [
                { name: '全部', status: '1' },
                { name: '处理中', status: '1' },
                { name: '代付款', status: '1' },
                { name: '未解决', status: '1' },
                { name: '已完成', status: '1' }
            ],
            detailInfo: {
                server_info: {}
            },
            chargeMoney: '',
            order_member_price: '',
            order_uuid: this.$route.query.order_uuid,
            isShowClose: true,
            isShowAgreeMent: false,
            isSuppleShow: false,
            isRescindShow: false,
            isRefundShow: false,
            isPayModal: false,
            isCommonShow: false,
            isRejectShow: false,
            isSuccess: false,
            isCommentShow: false,
            isRefund: false,
			clickOperate:true			//是否可以操作弹框
        };
    },

    created() {
        this.getOrderDetail();
    },

    methods: {
        // 获取订单详情
        async getOrderDetail() {
            const { data, status } = await getOrderDetail(this.order_uuid);
            if (status !== 200) return;
            this.detailInfo = data;
            this.detailInfo.statusName = utils.statusToName(this.detailInfo.order_status);
            this.detailInfo.question_url = this.detailInfo.question_url.split(',');
            if (this.detailInfo.statusName == '已撤单' || this.detailInfo.statusName == '待处理' || this.detailInfo.statusName == '已撤回') {
                this.detailInfo.statusName = '处理中';
            }

            // 判断是否超过5天
            let createTime = new Date(this.detailInfo.create_time.replace(/-/g, '/')).getTime(); //下单时间
            let noweTime = new Date().getTime(); //当前时间
            let fiveDayTime = 5 * 24 * 60 * 60 * 1000;
            if (noweTime - createTime > fiveDayTime) {
                //超过5天
                this.$set(this.detailInfo, 'isOverFive', true);
            } else {
                this.$set(this.detailInfo, 'isOverFive', false);
            }
            this.order_uuid = this.detailInfo.uuid;
        },

        // 取消订单,直接退款,完成
        cancelRefundComplete(num) {
            if (num == 1) {
                this.tipData = {
                    title: '是否取消当前订单',
                    num: 1
                };
                this.isCommonShow = true;
            } else if (num == 2) {
                this.tipData = {
                    title: '确定要申请退款么？',
                    content: '申请退款后，款项48小时内原路退回。',
                    num: 2
                };
                this.isCommonShow = true;
            } else if (num == 3) {
                this.tipData = {
                    title: '确定要完成订单么？',
                    content: '是否确认完成当前订单。',
                    num: 3
                };
                this.isCommonShow = true;
            }
        },

        // 确定取消订单,直接退款,完成
        submitTips(num) {
            switch (Number(num)) {
                case 1:
                    this.operateOrder('1');
                    break;
                case 2:
                    this.operateOrder('5');
                    break;
                case 3:
                    this.operateOrder('2');
                    break;
            }
        },

        // 立即评价
        comment() {
            const server_icon = this.detailInfo.server_info.server_icon;
            const server_name = this.detailInfo.server_info.server_name;
            this.isCommentShow = true;
            this.$refs.comment.getCommentInfo(this.order_uuid, server_icon, server_name);
        },

        // 立即支付
        payMent() {
            this.isPayModal = true;
            this.chargeMoney = this.detailInfo.order_total_price;
            this.order_member_price = this.detailInfo.order_member_price;
            this.$nextTick(() => {
                this.$refs.payModal.payClick(1);
            });
        },

        // 支付成功的回调
        getCallBack() {
            this.$nextTick(() => {
                this.isSuccess = true;
            });
        },

        // 支付成功查看订单详情
        backDetail() {
            this.getOrderDetail();
            this.isSuccess = false;
        },

        // 操作订单
        async operateOrder(type) {
			if(!this.clickOperate) {
				window.toast("请勿重复点击","txt");
				return;
			}
			this.clickOperate = false;
			setTimeout(()=>{
				this.clickOperate = true;
			},2000)
            const parmas = { type: type };
            const { data, status } = await operateOrder(this.order_uuid, parmas);
            if (status !== 200) return;
            if (type == 1) {
                // 取消订单
                this.getOrderDetail();
                this.isCommonShow = false;
                this.$message.success('订单取消成功');
            } else if (type == 5) {
                // 退款
                this.isRefund = true;
            } else if (type == 2) {
                // 完成订单
                this.getOrderDetail();
                this.$message.success('订单已完成');
                this.isCommonShow = false;
            }
        },

        // 确认补充
        submitSupple() {
            this.getOrderDetail();
            this.isSuppleShow = false;
        },

        // 退款详情页
        toRefundDetail() {
            this.isRefund = true;
        },

        follow() {
            this.$router.push({ path: './order-follow', query: { order_uuid: this.order_uuid, order_status: this.detailInfo.order_status } });
        },

        close() {
            clearTimeout(this.timer);
            this.isPayModal = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.componet-wrap {
    display: flex;
    justify-content: space-between;
    .left-componet {
        width: 54%;
    }
    .right-componet {
        width: 44%;
    }
}
.btn-text {
    span {
        @include cursor-style;
        display: block;
        height: 80px;
        line-height: 80px;
        text-align: center;
        background: #ff8e1c;
        box-shadow: 1px 8px 10px 1px rgba(32, 56, 118, 0.08);
        border-radius: 5px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
    }
    div {
        margin-top: 22px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        button {
            height: 60px;
            line-height: 60px;
            text-align: center;
            border-radius: 5px;
            font-size: 20px;
            @include font-style;
            @include cursor-style;
        }
        .pay {
            width: 30%;
            background: #ff8d1b;
            color: #ffffff;
        }
        .supply {
            width: 30%;
            background: #ffffff;
            border: 1px solid #ff8e1c;
            box-shadow: 1px 8px 10px 1px rgba(32, 56, 118, 0.08);
            color: #ff8e1c;
        }
        .rescind {
            width: 30%;
            background: #ffffff;
            border: 1px solid #9a9a9a;
            box-shadow: 1px 8px 10px 1px rgba(32, 56, 118, 0.08);
            color: #9a9a9a;
        }

        .debunk {
            width: 30%;
            background: #fff3e5;
            color: #ff9022;
        }
        .two-w {
            width: 60%;
        }

        .one-w {
            width: 100%;
        }
    }
}

//弹框按钮
.btn-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    .submit {
        @include cursor-style;
        width: 80px;
        height: 36px;
        line-height: 36px;
        box-sizing: border-box;
        text-align: center;
        background: #ff8e1c;
        box-shadow: 1px 3px 6px 0px rgba(102, 102, 102, 0.16);
        border-radius: 5px;
        font-size: 15px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
    }
    .cancel {
        @include cursor-style;
        @extend .submit;
        font-weight: 400;
        background: #ffffff;
        border: 1px solid #9a9a9a;
        color: #9a9a9a;
        margin-right: 20px;
    }
}
</style>
